
export type LineAttributePayload = {
  line: number;
  line_crossing_direction: LineDirection;
  backward_line_crossing: boolean;
};

export type LineDirection = typeof LineDirections[keyof typeof LineDirections];

export const LineDirections = {
  None: 'none',
  BA: 'BA',
  AB: 'AB'
} as const;
